<template>
  <router-link :to="`/cases/${item.id}`" class="case-card">
    <div class="cover">
      <img :src="imgUrl(item.cover, 'landscape_16_9')" :alt="item.title" loading="lazy" />
      <span class="type-tag">{{ item.typeName }}</span>
      <div class="cover-mask">
        <span class="view-btn">查看案例</span>
      </div>
    </div>
    <div class="body">
      <h3>{{ item.title }}</h3>
      <p>{{ item.summary }}</p>
      <div class="meta">
        <span>{{ item.industry }}</span>
        <span class="dot">·</span>
        <span>{{ item.duration }}</span>
      </div>
    </div>
  </router-link>
</template>

<script setup>
import { imgUrl } from '@/utils/img'

defineProps({
  item: { type: Object, required: true }
})
</script>

<style scoped>
.case-card {
  display: block;
  background: #fff;
  border-radius: var(--radius);
  overflow: hidden;
  border: 1px solid var(--hl-line);
  transition: all 0.35s ease;
}

.case-card:hover {
  transform: translateY(-8px);
  box-shadow: var(--shadow-lg);
}

.cover {
  position: relative;
  aspect-ratio: 16 / 10;
  overflow: hidden;
}

.cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s cubic-bezier(0.22, 0.61, 0.36, 1);
}

.case-card:hover .cover img {
  transform: scale(1.06);
}

.type-tag {
  position: absolute;
  top: 14px;
  left: 14px;
  padding: 5px 14px;
  border-radius: 30px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, var(--hl-blue), var(--hl-cyan));
  box-shadow: 0 4px 12px rgba(11, 92, 255, 0.4);
}

.cover-mask {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  background: linear-gradient(180deg, rgba(10, 30, 60, 0.1), rgba(10, 30, 60, 0.55));
  opacity: 0;
  transition: opacity 0.35s ease;
}

.case-card:hover .cover-mask {
  opacity: 1;
}

.view-btn {
  padding: 10px 24px;
  border-radius: 40px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  backdrop-filter: blur(6px);
  background: rgba(255, 255, 255, 0.12);
  transform: translateY(12px);
  transition: all 0.35s ease;
}

.case-card:hover .view-btn {
  transform: none;
}

.body {
  padding: 22px 24px 24px;
}

.body h3 {
  font-size: 18px;
  font-weight: 700;
  color: var(--hl-text);
  line-height: 1.5;
}

.body p {
  margin-top: 10px;
  font-size: 14px;
  color: var(--hl-text-2);
  line-height: 1.75;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.meta {
  margin-top: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--hl-blue);
  font-weight: 600;
}

.dot {
  color: var(--hl-line);
}
</style>
